<template>
  <div id="sidebar" :class="focused ? 'bg-glass disabled' : 'normal'" ref="sidebar">
    <div class="header user">
      <el-popover
        placement="bottom-start"
        width="180"
        popper-class="tools-popover account-popover"
        trigger="click"
        v-model="more_menu_show"
        :visible-arrow="false"
        @hide="handleHideMoreMenu"
      >
        <div class="nickname" :class="more_menu_show ? 'active' : ''" slot="reference" @click="clickSetting">
          <svg
            width="24"
            height="16"
            viewBox="0 0 24 16"
            fill="none"
            style="margin-right: 5px"
            class="pro-icon"
            v-bind:class="{ activePro: is_pro, proIcon: is_pro }"
            xmlns="http://www.w3.org/2000/svg"
          >
            <rect width="24" height="16" rx="3" fill="#9D9D9D" />
            <path
              d="M2.91431 4.5H5.45431C6.38097 4.5 7.07097 4.71 7.52431 5.13C7.97764 5.55 8.20431 6.11667 8.20431 6.83C8.20431 7.55 7.97764 8.12 7.52431 8.54C7.07097 8.96 6.38097 9.17 5.45431 9.17H4.34431V11.5H2.91431V4.5ZM5.45431 7.97C5.92764 7.97 6.26431 7.87667 6.46431 7.69C6.67097 7.49667 6.77431 7.21 6.77431 6.83C6.77431 6.45 6.67097 6.16667 6.46431 5.98C6.26431 5.78667 5.92764 5.69 5.45431 5.69H4.34431V7.97H5.45431Z"
              fill="white"
            />
            <path
              d="M9.31079 4.5H11.8808C12.3408 4.5 12.7408 4.55334 13.0808 4.66C13.4208 4.76667 13.7008 4.92 13.9208 5.12C14.1475 5.31334 14.3175 5.54667 14.4308 5.82C14.5441 6.08667 14.6008 6.38334 14.6008 6.71C14.6008 7.17 14.4941 7.57 14.2808 7.91C14.0741 8.25 13.7575 8.51 13.3308 8.69L14.8008 11.5H13.2408L11.9508 8.94H10.7408V11.5H9.31079V4.5ZM11.8808 7.74C12.3408 7.74 12.6708 7.65 12.8708 7.47C13.0708 7.29 13.1708 7.03667 13.1708 6.71C13.1708 6.39 13.0708 6.14 12.8708 5.96C12.6708 5.78 12.3408 5.69 11.8808 5.69H10.7408V7.74H11.8808Z"
              fill="white"
            />
            <path
              d="M18.3056 11.59C17.4456 11.59 16.7656 11.3233 16.2656 10.79C15.7723 10.25 15.5256 9.42334 15.5256 8.31V7.51C15.5256 6.49 15.7723 5.72 16.2656 5.2C16.7656 4.67334 17.4456 4.41 18.3056 4.41C19.1656 4.41 19.8423 4.67334 20.3356 5.2C20.8356 5.72 21.0856 6.49 21.0856 7.51V8.31C21.0856 9.42334 20.8356 10.25 20.3356 10.79C19.8423 11.3233 19.1656 11.59 18.3056 11.59ZM18.3056 10.36C18.5123 10.36 18.699 10.3267 18.8656 10.26C19.039 10.1933 19.1823 10.08 19.2956 9.92C19.409 9.76 19.4956 9.55 19.5556 9.29C19.6223 9.02334 19.6556 8.69667 19.6556 8.31V7.51C19.6556 6.83667 19.5356 6.35667 19.2956 6.07C19.0556 5.78334 18.7256 5.64 18.3056 5.64C17.8856 5.64 17.5556 5.78334 17.3156 6.07C17.0756 6.35667 16.9556 6.83667 16.9556 7.51V8.31C16.9556 8.69667 16.9856 9.02334 17.0456 9.29C17.1123 9.55 17.2023 9.76 17.3156 9.92C17.429 10.08 17.569 10.1933 17.7356 10.26C17.9023 10.3267 18.0923 10.36 18.3056 10.36Z"
              fill="white"
            />
          </svg>

          <div class="name">{{ user ? render_name : '' }}</div>
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M3.71484 4.75L2.96484 5.5L6 8.53516L9.03516 5.5L8.28516 4.75L6 7.03516L3.71484 4.75Z" />
          </svg>
        </div>
        <div class="popover-menu">
          <div
            class="item"
            v-baidu-event-tracking="{ feature: '下载客户端', action: '左上角菜单' }"
            @click.stop="installAppButtonClicked"
            v-if="$isMobile() && !is_quickapp && !isElectron"
          >
            {{ $t('sidebar.menu.app') }}
          </div>
          <div
            class="item"
            @click.stop="clickAccount"
            v-baidu-event-tracking="{ feature: '左上角菜单', action: '账号详情' }"
          >
            <div>{{ $t('sidebar.menu.account') }}</div>
            <div class="desc">{{ $t('sidebar.menu.desc') }}</div>
          </div>
          <el-divider class="divider"></el-divider>
          <div
            class="item"
            @click.stop="clickMembership"
            v-baidu-event-tracking="{ feature: '左上角菜单', action: '会员中心' }"
          >
            {{ $t('sidebar.menu.membership') }}
          </div>
          <div class="item" @click="clickStat" v-baidu-event-tracking="{ feature: '左上角菜单', action: '记录统计' }">
            {{ $t('pages.RecordStat.title') }}
          </div>
          <div
            class="item action"
            @click.stop="clickNotifications"
            v-baidu-event-tracking="{ feature: '查看通知', action: '左侧下拉菜单' }"
          >
            <span>{{ $t('sidebar.menu.notice') }}</span>
            <span class="redDot" v-if="has_unread_notifications && isItNewMessage">{{
              unread_notification_count
            }}</span>
          </div>

          <div
            class="item"
            @click.stop="clickReferral"
            v-baidu-event-tracking="{ feature: '左上角菜单', action: '奖励计划' }"
          >
            {{ $t('sidebar.menu.gift') }}
          </div>
          <div
            class="item"
            @click.stop="clickIncomingWebhook"
            v-baidu-event-tracking="{ feature: '左上角菜单', action: 'API' }"
          >
            {{ $t('sidebar.menu.api') }}
          </div>
          <div
            class="item"
            @click.stop="clickHelp"
            v-baidu-event-tracking="{ feature: '左上角菜单', action: '帮助教程' }"
          >
            {{ $t('sidebar.menu.help') }}
          </div>
          <div
            class="item"
            @click.stop="clickFeedback"
            v-baidu-event-tracking="{ feature: '左上角菜单', action: '沟通反馈' }"
          >
            {{ $t('sidebar.menu.feedback') }}
          </div>
          <div
            class="item"
            @click.stop="download"
            v-baidu-event-tracking="{ feature: '下载客户端', action: '左上角菜单' }"
          >
            {{ $t('electron.menu.application.help.download') }}
          </div>

          <el-divider class="divider"></el-divider>
          <div
            class="item action"
            @click.stop="lock"
            v-baidu-event-tracking="{ feature: '左上角菜单', action: '立即锁定' }"
          >
            <span>{{ $t('sidebar.menu.lock') }}</span>

            <svg
              style="margin-right: 5px"
              class="activePro proIcon"
              width="24"
              height="16"
              viewBox="0 0 24 16"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect width="24" height="16" rx="3" fill="#212F4B" />
              <path
                d="M2.91431 4.5H5.45431C6.38097 4.5 7.07097 4.71 7.52431 5.13C7.97764 5.55 8.20431 6.11667 8.20431 6.83C8.20431 7.55 7.97764 8.12 7.52431 8.54C7.07097 8.96 6.38097 9.17 5.45431 9.17H4.34431V11.5H2.91431V4.5ZM5.45431 7.97C5.92764 7.97 6.26431 7.87667 6.46431 7.69C6.67097 7.49667 6.77431 7.21 6.77431 6.83C6.77431 6.45 6.67097 6.16667 6.46431 5.98C6.26431 5.78667 5.92764 5.69 5.45431 5.69H4.34431V7.97H5.45431Z"
                fill="white"
              />
              <path
                d="M9.31079 4.5H11.8808C12.3408 4.5 12.7408 4.55334 13.0808 4.66C13.4208 4.76667 13.7008 4.92 13.9208 5.12C14.1475 5.31334 14.3175 5.54667 14.4308 5.82C14.5441 6.08667 14.6008 6.38334 14.6008 6.71C14.6008 7.17 14.4941 7.57 14.2808 7.91C14.0741 8.25 13.7575 8.51 13.3308 8.69L14.8008 11.5H13.2408L11.9508 8.94H10.7408V11.5H9.31079V4.5ZM11.8808 7.74C12.3408 7.74 12.6708 7.65 12.8708 7.47C13.0708 7.29 13.1708 7.03667 13.1708 6.71C13.1708 6.39 13.0708 6.14 12.8708 5.96C12.6708 5.78 12.3408 5.69 11.8808 5.69H10.7408V7.74H11.8808Z"
                fill="white"
              />
              <path
                d="M18.3056 11.59C17.4456 11.59 16.7656 11.3233 16.2656 10.79C15.7723 10.25 15.5256 9.42334 15.5256 8.31V7.51C15.5256 6.49 15.7723 5.72 16.2656 5.2C16.7656 4.67334 17.4456 4.41 18.3056 4.41C19.1656 4.41 19.8423 4.67334 20.3356 5.2C20.8356 5.72 21.0856 6.49 21.0856 7.51V8.31C21.0856 9.42334 20.8356 10.25 20.3356 10.79C19.8423 11.3233 19.1656 11.59 18.3056 11.59ZM18.3056 10.36C18.5123 10.36 18.699 10.3267 18.8656 10.26C19.039 10.1933 19.1823 10.08 19.2956 9.92C19.409 9.76 19.4956 9.55 19.5556 9.29C19.6223 9.02334 19.6556 8.69667 19.6556 8.31V7.51C19.6556 6.83667 19.5356 6.35667 19.2956 6.07C19.0556 5.78334 18.7256 5.64 18.3056 5.64C17.8856 5.64 17.5556 5.78334 17.3156 6.07C17.0756 6.35667 16.9556 6.83667 16.9556 7.51V8.31C16.9556 8.69667 16.9856 9.02334 17.0456 9.29C17.1123 9.55 17.2023 9.76 17.3156 9.92C17.429 10.08 17.569 10.1933 17.7356 10.26C17.9023 10.3267 18.0923 10.36 18.3056 10.36Z"
                fill="white"
              />
            </svg>
          </div>
          <div class="item" @click.stop="logout" v-baidu-event-tracking="{ feature: '左上角菜单', action: '退出' }">
            {{ $t('sidebar.menu.logout') }}
          </div>
        </div>
      </el-popover>
      <div
        class="flomo-fade"
        @click="hideSide"
        v-baidu-event-tracking="{ feature: '侧边栏收缩', action: '收起' }"
        v-if="sidebarShow == 1 && !$isMobile()"
        @mouseenter="hideSideTip = true"
        @mouseleave="hideSideTip = false"
      >
        <el-tooltip placement="bottom" :transition="''" v-model="hideSideTip">
          <div slot="content" style="font-size: 12px">
            <p>{{ $t('sidebar.hide') }}</p>
            <p style="color: #9d9d9d; margin-top: 6px">{{ getSidebarKey }}</p>
          </div>
          <svg-icon :iconClass="'leftArrow'"></svg-icon>
        </el-tooltip>
      </div>
      <div
        class="flomo-fade"
        @click="showSide"
        v-if="sidebarShow == 0 && !$isMobile()"
        @mouseenter="showSideTip = true"
        @mouseleave="showSideTip = false"
        v-baidu-event-tracking="{ feature: '侧边栏收缩', action: '展开' }"
      >
        <el-tooltip placement="bottom" :transition="''" v-model="showSideTip">
          <div slot="content" style="font-size: 12px">
            <p>{{ $t('sidebar.show') }}</p>
            <p style="color: #9d9d9d; margin-top: 6px">{{ getSidebarKey }}</p>
          </div>
          <svg-icon :iconClass="'rArrow'"></svg-icon>
        </el-tooltip>
      </div>
    </div>
    <div class="stat" v-if="user">
      <div class="datas" v-baidu-event-tracking="{ feature: '热力图', action: '点击数据' }">
        <div class="data" @click="clickStat">
          <div class="number">{{ memo_count }}</div>
          <div class="type">MEMO</div>
        </div>
        <div class="data" @click="clickStat">
          <div class="number">{{ tag_count }}</div>
          <div class="type">TAG</div>
        </div>
        <div class="data" @click="clickStat">
          <div class="number">{{ used_day_count }}</div>
          <div class="type">DAY</div>
        </div>
      </div>
      <div class="heatgridTip" v-if="is_new_user && heatgridHelpDialog == -1 && !$isMobile()">
        <TipBarVue
          v-baidu-event-tracking="{ feature: '热力图_提示banner', action: '点击' }"
          :tip-content="$t('sidebar.heatgridTip')"
          :tip-click="showHeatgridTipDialog"
          isHeatgrid
        />
      </div>
      <div class="heatgrid" v-baidu-event-tracking="{ feature: '热力图', action: '点击方格' }">
        <div class="week" v-for="i in Array.from({ length: 12 }).map((v, k) => k)" v-bind:key="i">
          <el-tooltip
            :content="tooltip_of_grid(i, j)"
            placement="top"
            :open-delay="300"
            :disabled="is_mobile"
            v-for="j in Array.from({ length: 7 }).map((v, k) => k)"
            v-bind:key="j"
          >
            <div
              class="day"
              v-bind:class="{
                light_green: memo_count_of_grid(i, j) > 0 && memo_count_of_grid(i, j) < 5,
                green: memo_count_of_grid(i, j) >= 5 && memo_count_of_grid(i, j) < 10,
                dark_green: memo_count_of_grid(i, j) >= 10,
                today: is_today(i, j),
              }"
              @click="clickGrid(i, j)"
            ></div>
          </el-tooltip>
        </div>
      </div>
      <div class="heatgrid monthBox">
        <div class="month" v-for="i in Array.from({ length: 12 }).map((v, k) => k)" :key="i + 'month'">
          {{ getMonthByIndex(i, 6) ? $t('sidebar.month.' + getMonthByIndex(i, 6)) : '' }}
        </div>
      </div>
    </div>
    <ul class="sidebar_ul">
      <li
        v-bind:class="{ selected: selected_tag == null && pinned_selected_tag == null && !selected_source }"
        @click="clickMemo"
      >
        <svg-icon :iconClass="'memo'"></svg-icon>
        <div>MEMO</div>
      </li>
      <li v-bind:class="{ selected: selected_source == 'wechat' }" @click="clickWechat">
        <svg-icon :iconClass="'wx'"></svg-icon>
        <div>
          {{ $t('sidebar.wechat_input') }}
        </div>
      </li>
      <li
        v-bind:class="{
          selected: selected_source == 'notify',
        }"
        @click="clickNotify"
      >
        <svg-icon :iconClass="'magic'"></svg-icon>
        <div>
          {{ $t('sidebar.daily_notify') }}
        </div>
      </li>
      <li v-if="showRandonWalk" v-bind:class="{ selected: selected_source == 'lucky' }" @click="clickLucky">
        <svg-icon :iconClass="'randomStep'"></svg-icon>
        <div>
          {{ $t('sidebar.random_walk') }}
        </div>
      </li>
    </ul>

    <h3 v-if="pinned_tag_tree.length || tags.length >= 10">
      {{ $t('sidebar.pinned_tags') }}
    </h3>
    <ul class="tags pinned_tags" v-if="pinned_tag_tree.length">
      <tag-tree
        v-for="tag_info in pinned_tag_tree"
        v-bind:key="tag_info.value"
        :pinned="true"
        :level="1"
        :tag_info="tag_info"
        :selected_tag="pinned_selected_tag"
        v-bind:class="{ selected: pinned_selected_tag == tag_info.value }"
        v-on:tag-clicked="clickTag"
        v-on:rename-tag-clicked="renameTagClicked"
        v-on:change-tag-icon-clicked="changeTagIconClick"
      >
      </tag-tree>
    </ul>
    <div v-if="pinnedTip">
      <div class="pinned_tip" v-if="pinned_tag_tree.length == 0">
        <TipBarVue
          v-baidu-event-tracking="{ feature: '置顶标签_提示banner', action: '点击' }"
          :tip-content="$t('sidebar.pinned_tags_placeholder')"
          :tip-close="closePinnedTip"
        />
      </div>
    </div>
    <div class="allTags">
      <div class="allTags_header">
        <div>
          <i
            @click.stop.prevent="expandAllTags()"
            v-bind:class="{
              'arrow-down': expand_all_tags,
              'arrow-right': !expand_all_tags,
            }"
          >
            <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path
                d="M8.48532 5.6038C8.74532 5.80395 8.74532 6.19605 8.48532 6.3962L4.18 9.71044C3.85121 9.96354 3.375 9.72916 3.375 9.31424L3.375 2.68576C3.375 2.27084 3.85121 2.03646 4.18 2.28956L8.48532 5.6038Z"
                fill="#9D9D9D"
              />
            </svg>
          </i>
          <span class="allTags_title" @click.stop.prevent="expandAllTags">
            {{ $t('sidebar.allTags') }}
          </span>
        </div>
        <!-- <span
          @click="clickTags"
          class="rightIcon"
          @mouseenter="showTagManageTip = true"
          @mouseleave="showTagManageTip = false"
        >
          <el-tooltip
            placement="bottom"
            :transition="''"
            v-model="showTagManageTip"
            :content="$t('sidebar.tagManage')"
            :disabled="is_mobile"
          >
            <svg-icon icon-class="tagSet"></svg-icon>
          </el-tooltip>
        </span> -->
      </div>
      <LayTransition>
        <ul class="tags allTags_body" v-if="expand_all_tags" style="display: block">
          <tag-tree
            v-for="(tag_info, index) in visibleTags"
            v-bind:key="tag_info.value"
            :pinned="false"
            :level="1"
            :tag_info="tag_info"
            :selected_tag="selected_tag"
            v-bind:class="{ selected: selected_tag == tag_info.value }"
            v-on:tag-clicked="clickTag"
            v-on:rename-tag-clicked="renameTagClicked"
            v-on:change-tag-icon-clicked="changeTagIconClick"
          >
          </tag-tree>
          <h3 v-if="tags_overlimit && !show_all_tags" @click="clickShowAllTags" class="tag_overlimit">
            {{ $t('sidebar.tags_overlimit') }}
          </h3>
        </ul>
      </LayTransition>
    </div>

    <h3 class="recycle" @click="clickRecycle" v-bind:class="{ selected: selected_source == 'recycle' }">
      <svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M1.037 2.225C1.0125 2.15251 1.00001 2.07651 1 2C1 0.895 3.686 0 7 0C10.314 0 13 0.895 13 2C13 2.07652 12.9875 2.15252 12.963 2.225L11.279 12.329C11.2011 12.7962 10.9599 13.2205 10.5984 13.5265C10.237 13.8325 9.77861 14.0003 9.305 14H4.694C4.22056 14.0001 3.76245 13.8322 3.40118 13.5262C3.0399 13.2202 2.79888 12.796 2.721 12.329L1.037 2.225ZM10.927 1.535C9.966 1.214 8.578 1 7 1C5.42 1 4.032 1.215 3.074 1.534C2.597 1.694 2.279 1.861 2.099 2C2.279 2.14 2.597 2.307 3.074 2.466C4.032 2.786 5.42 3 7 3C8.58 3 9.967 2.785 10.926 2.466C11.403 2.306 11.721 2.139 11.901 2C11.721 1.86 11.403 1.693 10.926 1.534L10.927 1.535Z"
        />
      </svg>
      {{ $t('sidebar.recycl') }}
    </h3>
    <div class="placeholder-div"></div>
  </div>
</template>
<script>
var dayjs = require('dayjs')
var isoWeek = require('dayjs/plugin/isoWeek')
dayjs.extend(isoWeek)

import TagTree from '../components/TagTree.vue'
import DBUtil from '../utils/DBUtil.js'

import { getOsType } from '../utils/utils'
import LayTransition from '../components/LayTransition'
import logClickEvent from '../utils/logClickEvent'
import TipBarVue from '../components/Tips/bar.vue'
import confirmMixin from '@/mixins/confirmMixin'
import emitter from '../utils/eventbus.js'
import emailSetupReminderMixin from '@/mixins/emailSetupReminder'
export default {
  components: {
    TagTree,
    LayTransition,
    TipBarVue,
  },
  mixins: [confirmMixin, emailSetupReminderMixin],
  data() {
    return {
      user: this.$store.state.me,
      stat: [],
      more_menu_show: false,
      is_quickapp: false, // is_quickapp,
      expand_all_tags: this.$store.state.expand_all_tags,
      tooltip: {},
      isItNewMessage: false,
      isElectron: this.$store.getters.isElectron,
      isProduction: this.$store.getters.isProduction,
      tags_overlimit: false,
      show_all_tags: false,
      showSideTip: false,
      hideSideTip: false,
      defaultProps: {
        children: 'children',
        label: 'display',
      },
      showTagManageTip: false,
      pageSize: 100, // 每页数据量
      currentPage: 1, // 当前页码
    }
  },
  computed: {
    heatgridHelpDialog() {
      return this.$store.getters['onboarding/heatgridHelpDialog']
    },
    is_new_user() {
      return this.$store.getters.is_new_user
    },
    is_mobile() {
      return this.$store.state.is_mobile
    },
    is_android() {
      return this.$store.state.is_android
    },
    is_pro() {
      return this.$store.getters.is_pro
    },
    has_unread_notifications() {
      for (let i in this.$store.state.notifications) {
        let notification = this.$store.state.notifications[i]
        if (!notification.readed) return true
      }
      return false
    },
    tag_count() {
      return this.$store.state.tags.filter((tag) => tag.name).length
    },
    memo_count() {
      return this.$store.state.memo_count
    },
    used_day_count() {
      return this.$store.getters.used_day_count
    },
    showRandonWalk() {
      return dayjs(this.user.created_at).isBefore(dayjs('2021-11-15'))
    },

    pinned_selected_tag() {
      return this.$store.state.pinned_selected_tag
    },
    selected_tag() {
      return this.$store.state.selected_tag
    },
    selected_source() {
      return this.$store.state.selected_source
    },
    tags() {
      return this.$store.state.tags
    },
    tag_tree() {
      let expand_tags = {}
      let root = []

      for (const [index, tag] of this.$store.state.tags.entries()) {
        let segments = tag.name.split('/')
        let parent_value = null

        for (const segment of segments) {
          let value = parent_value || parent_value === '' ? parent_value + '/' + segment : segment
          if (value === 'length') continue // length 是 array 的保留字，所以注释掉。不是一个好的做法。
          if (!expand_tags[value]) {
            expand_tags[value] = {
              display: segment,
              value: value,
              parent_value: parent_value,
              children: [],
              icon: tag.icon_value ? tag.icon_value : '',
              order: null,
              id: tag.id,
              name: value,
            }
          }
          parent_value = value
        }

        if (!this.show_all_tags && index >= 1000) {
          this.tags_overlimit = true
          break
        }
      }

      for (const key in expand_tags) {
        let node = expand_tags[key]
        const tag = this.$store.state.tags.find((t) => t.name === node.value)
        node.order = tag && tag.order ? tag.order : null
        node.icon = tag && tag.icon_value ? tag.icon_value : ''
        if (node.parent_value || node.parent_value === '') {
          expand_tags[node.parent_value].children.push(node)
        } else {
          root.push(node)
        }
      }

      //遍历所有children节点都sort一下
      for (const key in expand_tags) {
        let item = expand_tags[key]
        if (item.children) {
          DBUtil.sortChildren(item.children)
        }
      }

      // sort root
      DBUtil.sortTags(root)
      return root
    },
    loadTagEnd() {
      return this.currentPage * 100 >= this.tag_tree.length
    },
    visibleTags() {
      return this.tag_tree.slice(0, this.currentPage * 100)
    },
    latest_tag_tree() {
      // 合并最近未用到的子标签
      let latest_tags = Object.assign([], this.$store.state.latest_tags)
      for (const index in this.$store.state.latest_tags) {
        let tag = this.$store.state.latest_tags[index]
        let segments = tag.split('/')
        let firstSegment = segments[0]

        for (const i in this.$store.state.tags) {
          let tag2 = this.$store.state.tags[i]
          if (tag2.startsWith(firstSegment + '/')) {
            if (tag2 == tag) continue
            latest_tags.push(tag2)
          }
        }
      }

      let expand_tags = []
      for (const index in latest_tags) {
        let tag = latest_tags[index]
        let segments = tag.split('/')

        let parent_value = ''
        for (const i in segments) {
          let segment = segments[i]
          let value = parent_value ? parent_value + '/' + segment : segment
          expand_tags[value] = {
            display: segment,
            value: value,
            parent_value: parent_value,
            children: [],
          }

          parent_value = value
        }
      }

      let map = {},
        node,
        root = [],
        i
      for (const key in expand_tags) {
        node = expand_tags[key]
        if (node.parent_value) {
          expand_tags[node.parent_value].children.push(node)
        } else {
          root.push(node)
        }
      }

      return root
    },
    pinned_tag_tree() {
      let expand_tags = []
      for (const index in this.$store.state.pinned_tags) {
        let tag_name = this.$store.state.pinned_tags[index].name
        const icon = this.$store.state.pinned_tags[index].icon_value
          ? this.$store.state.pinned_tags[index].icon_value
          : ''
        let expand_tag = {
          display: tag_name,
          value: tag_name,
          parent_value: '',
          children: [],
          icon,
        }

        // 绑定子级标签
        let tags = this.tag_tree
        while (tags.length > 0) {
          let looped_all = true
          for (const index2 in tags) {
            let tag = tags[index2]
            if (tag.value == tag_name) {
              expand_tag.children = tag.children
              tags = []
              looped_all = false
              break
            } else if (tag_name.startsWith(tag.value + '/')) {
              tags = tag.children
              looped_all = false
              break
            }
          }
          if (looped_all) tags = []
        }

        expand_tags.push(expand_tag)
      }
      return expand_tags
    },

    unread_notification_count() {
      return this.$store.state.notifications.filter((notification) => !notification.readed).length
    },
    render_name() {
      const { name } = this.$store.state.me
      if (name && name.length > 8) {
        return name.substring(0, 8) + '...'
      } else {
        return name
      }
    },
    focused() {
      return this.$store.state.focused
    },
    isMac() {
      return getOsType() == 'mac'
    },
    sidebarShow() {
      return this.$store.state.sidebarShow
    },
    getSidebarKey() {
      return this.$store.state.hotkeys.filter((hotkey) => hotkey.action == 'toggleSidebar')[0].key.replace('Meta', '⌘')
    },
    pinnedTip() {
      return this.$store.state.pinnedTip == 1
    },
    expandedTagValues() {
      return this.$store.state.expandedTagValues
    },
    wechat_offical_account() {
      return this.$store.getters['thirdParty/wechat_offical_account']
    },
    isApplePrivateEmail() {
      return this.$store.getters.isApplePrivateEmail
    },
  },
  methods: {
    showHeatgridTipDialog() {
      this.$store.dispatch('onboarding/setHeatgridHelpDialog', '1')
    },
    maxHeight() {
      return this.$store.state.tags.length * 25 + 'px'
    },
    clickTags() {
      this.showTagManageTip = false
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'tags')
      this.$emit('tag-clicked')
    },
    closePinnedTip() {
      this.$store.commit('setPinnedTip', 0)
    },
    getMonthByIndex(i, j) {
      const currentMonth = dayjs()
        .startOf('isoWeek')
        .subtract(11 - i, 'week')
        .add(j, 'day')
        .format('M')
      const frontMonth = dayjs()
        .startOf('isoWeek')
        .subtract(11 - i + 1, 'week')
        .add(j, 'day')
        .format('M')
      if (currentMonth == frontMonth && i != 0) {
        return ''
      }
      return currentMonth
    },
    async resetFilter() {
      this.$store.dispatch('resetFilter')
    },
    clickNotifications() {
      this.more_menu_show = false
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'notifications')
      this.$emit('tag-clicked')
    },
    clickSetting() {
      const notification_id = localStorage.notification_id
      this.isItNewMessage =
        notification_id &&
        this.$store.state.notifications.length &&
        this.$store.state.notifications[0].id != notification_id
    },
    clickReferral() {
      this.more_menu_show = false
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'referral')
      this.$emit('tag-clicked')
    },

    clickIncomingWebhook() {
      this.more_menu_show = false
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'incoming_webhook')
      this.$emit('tag-clicked')
    },
    clickAccount() {
      this.more_menu_show = false
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'account')
      this.$emit('tag-clicked')
    },
    clickHelp() {
      this.more_menu_show = false
      if (this.isElectron) {
        return window.ipcRenderer.send('openUrl', 'https://help.flomoapp.com/')
      }
      window.open('https://help.flomoapp.com/', '_blank')
    },
    clickFeedback() {
      const url = {
        en: 'https://discord.gg/sk9KYeHAy3',
        zh: 'https://help.flomoapp.com/community/wechat-group.html',
      }
      this.more_menu_show = false
      if (this.isElectron) {
        return window.ipcRenderer.send('openUrl', url[this.$store.state.me.language.toLowerCase().slice(0, 2)])
      }
      window.open(url[this.$store.state.me.language.toLowerCase().slice(0, 2)], '_blank')
    },
    clickMemo() {
      this.resetFilter()
      this.$emit('tag-clicked')
    },
    clickNotify() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'notify')
      this.$emit('tag-clicked')
    },
    clickLucky() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'lucky')
      this.$emit('tag-clicked')
    },
    clickMembership() {
      this.more_menu_show = false
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'membership')
      this.$emit('tag-clicked', 'from=sidemenu')
    },
    clickWechat() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'wechat')
      this.$store.dispatch('loadWechatInfo')
      this.$store.dispatch('thirdParty/getWechatAccount')
      // 轮训检查是否绑定了微信
      if (!this.wechat_offical_account) {
        this.$store.dispatch('thirdParty/getWechatAccountInterval')
      }
      this.$emit('tag-clicked')
    },
    clickShowAllTags() {
      this.$confirm(
        this.$t('components.TagTree.show_all_tags_message.text'),
        this.$t('components.TagTree.show_all_tags_message.title'),
        {
          confirmButtonText: this.$t('components.TagTree.show_all_tags_message.confirm'),
          cancelButtonText: this.$t('components.TagTree.show_all_tags_message.cancel'),
          confirmButtonClass: 'delete-confirm-button',
        },
      )
        .then(() => {
          this.show_all_tags = true
        })
        .catch(() => {})
    },
    memo_count_of_grid(i, j) {
      let date = dayjs()
        .startOf('isoWeek')
        .subtract(11 - i, 'week')
        .add(j, 'day')
      let dateStr = date.format('YYYY-MM-DD')

      let memo_count = this.$store.state.daily_memo_count.hasOwnProperty(dateStr)
        ? this.$store.state.daily_memo_count[dateStr]
        : 0
      return memo_count
    },
    tooltip_of_grid(i, j) {
      let date = dayjs()
        .startOf('isoWeek')
        .subtract(11 - i, 'week')
        .add(j, 'day')
      let dateStr = date.format('YYYY-MM-DD')

      let memo_count = this.memo_count_of_grid(i, j)
      if (memo_count <= 1) {
        return memo_count + ' memo on ' + dateStr
      } else {
        return memo_count + ' memos on ' + dateStr
      }
    },
    is_today(i, j) {
      let date = dayjs()
        .startOf('isoWeek')
        .subtract(11 - i, 'week')
        .add(j, 'day')
      let today = dayjs()
      return date.isSame(today, 'date')
    },
    clickGrid(i, j) {
      let memo_count = this.memo_count_of_grid(i, j)
      if (memo_count < 1) return

      let date = dayjs()
        .startOf('isoWeek')
        .subtract(11 - i, 'week')
        .add(j, 'day')
      let dateStr = date.format('YYYY-MM-DD')
      this.$store.commit('setStartDate', dateStr)
      this.$store.commit('setEndDate', dateStr)
      this.$store.commit('setSelectedSource', null)
      this.$store.commit('setSelectedTag', null)
      this.$store.commit('setType', null)
      this.$emit('tag-clicked')
    },
    clickTag(value, pinned) {
      this.$store.commit('setStartDate', null)
      this.$store.commit('setEndDate', null)
      this.$store.commit('setSelectedSource', null)
      this.$store.commit('setQuery', null)
      if (pinned) {
        this.$store.commit('setPinnedSelectedTag', value)
        this.$store.commit('setSelectedTag', null)
      } else {
        this.$store.commit('setSelectedTag', value)
        this.$store.commit('setPinnedSelectedTag', null)
      }
      this.$store.commit('setType', null)

      this.$emit('tag-clicked')
    },
    async logout() {
      this.hasSyncPendingMemos(
        this.$t('components.logout.tips.content'),
        this.$t('components.logout.tips.title'),
        this.$t('components.logout.tips.confirm'),
        this.$t('components.logout.tips.cancel'),
        () => {
          this.$store.dispatch('logout')
        },
      )
    },
    resetDB() {
      this.$confirm('此操作将删除本地数据并重新拉取线上数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(() => {
          DBUtil.resetDB().then(() => {
            window.location.reload()
          })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消',
          })
        })
    },
    installAppButtonClicked() {
      this.more_menu_show = false
      window.open('https://a.app.qq.com/o/simple.jsp?pkgname=com.flomo.app', '_blank')
    },
    /* Rename Tag */
    renameTagClicked(tag_position, tag_name, isTree, level, parentNodeWidth) {
      this.$emit('rename-tag-clicked', tag_position, tag_name, isTree, level, parentNodeWidth)
    },
    /* expandAllTags */
    expandAllTags() {
      this.expand_all_tags = !this.expand_all_tags
      this.$store.commit('expandAllTags', this.expand_all_tags)
    },
    clickRecycle() {
      this.more_menu_show = false
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'recycle')
      this.$emit('tag-clicked')
    },
    /* changeTagIconClick */
    changeTagIconClick(value, tag_name) {
      this.$emit('change-tag-icon-clicked', value, tag_name)
    },
    handleHideMoreMenu() {
      document.querySelector('.account-popover').remove()
    },
    lock() {
      if (!this.$store.getters.is_pro) {
        this.$confirm(this.$t('components.only_pro.tips.content'), this.$t('pages.Account.password_mode.title'), {
          confirmButtonText: this.$t('components.only_pro.tips.confirm'),
          customClass: 'confirm',
          dangerouslyUseHTMLString: true,
          showCancelButton: false,
        })
          .then(() => {
            this.more_menu_show = false
            this.resetFilter()
            this.$store.commit('setSelectedSource', 'membership')
            this.$emit('tag-clicked', 'from=sidemenu_passcode')
          })
          .catch(() => {})
        return
      }
      this.more_menu_show = false
      if (this.isApplePrivateEmail) {
        this.alertSetAccount(() => {
          emitter.emit('modify-account-dialog-toggle', true)
        })
        return
      }
      this.$store.commit('setLock', 1)
    },
    download() {
      const url =
        this.user.language != 'en'
          ? 'https://help.flomoapp.com/basic/app.html'
          : 'https://help.flomo.app/basic/download'
      if (this.isElectron) {
        window.ipcRenderer.send('openUrl', url)
      } else {
        window.open(url, '_blank')
      }
    },
    clickStat() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'stat')
      this.$emit('tag-clicked')
      this.more_menu_show = false
    },
    clickExport() {
      this.resetFilter()
      this.$store.commit('setSelectedSource', 'export')
      this.$emit('tag-clicked')
      this.more_menu_show = false
    },
    hideSide() {
      if (this.is_mobile || document.body.clientWidth < 640) {
        this.$emit('closeSidebar')
        return
      }
      this.hideSideTip = false
      this.$store.commit('setSidebarShow', 0)
    },
    showSide() {
      this.showSideTip = false

      this.$store.commit('setSidebarShow', 1)
      this.$emit('hide-fixedSide')
    },
    handleScroll() {
      const asideContainer = document.querySelector('.aside-container')
      const isBottom = asideContainer.scrollHeight - asideContainer.scrollTop + 200 >= asideContainer.clientHeight
      if (this.loadTagEnd) {
        return
      }
      if (isBottom) {
        this.currentPage++
      }
    },
  },
  mounted() {
    this.$nextTick(() => {
      document.querySelector('.aside-container') &&
        document.querySelector('.aside-container').addEventListener('scroll', this.handleScroll)
    })

    if (this.is_new_user && this.heatgridHelpDialog == -1 && !this.$isMobile()) {
      logClickEvent('热力图提示 Banner', '展示')
    }
  },
  beforeDestroy() {
    document.querySelector('.aside-container') &&
      document.querySelector('.aside-container').removeEventListener('scroll', this.handleScroll)
  },
}
</script>
<style scoped>
@import '/public/css/heatgrid.css';

#sidebar {
  width: 100%;
  height: 100%;
}
.aside-container #sidebar {
  width: unset;
}

#sidebar:hover .header .flomo-fade {
  opacity: 1;
}

.header {
  height: 65px;
}
.header .flomo-fade {
  width: 32px;
  height: 32px;

  text-align: center;
  cursor: pointer;
  opacity: 0;
  transition: opacity 0.3s;
}

.header .flomo-fade:hover {
  background: var(--hoverBg);
  border-radius: 6px;
}

.header .flomo-fade svg {
  width: 12px;
  height: 12px;
  padding: 10px 0;
}

.user {
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
}

.user .nickname {
  font-size: 18px;
  font-weight: bold;
  color: #5f5f5f;
  overflow: hidden;
  padding: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  margin-left: -6px;
}

.user .nickname:hover,
.user .active {
  background: var(--active-background-color);
  border-radius: 4px;
}

.user .nickname .name {
  cursor: pointer;
  max-width: 120px;
  margin-right: 4px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.user svg {
  fill: var(--svgFill);
}

.pro {
  color: white;
  background: #9d9d9d;
  font-size: 12px;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
  margin-right: 5px;
  font-weight: bold;
}
.pro-icon rect {
  fill: #9d9d9d;
}
.pro-icon path {
  fill: white;
}
.activePro rect {
  fill: #212f4b;
}
.activePro path {
  fill: white;
}

.user .notice {
  margin-right: 10px;
  cursor: pointer;
  position: relative;
}

.user .notice svg,
.user .setting svg {
  stroke: #9d9d9d;
}

.user .notice svg:hover,
.user .setting svg:hover {
  stroke: #000000;
}

.dark_mode .user .notice svg:hover,
.dark_mode .user .setting svg:hover {
  stroke: #e3e3e3;
}

.user .setting {
  cursor: pointer;
  position: relative;
}

.red_pointer:before {
  content: ' ';
  border: 3px solid #ff1a1a;
  border-radius: 3px;
  position: absolute;
  z-index: 1000;
  right: 0%;
  margin-right: -4px;
  margin-top: -4px;
}

.more-menu-button.red_pointer:before {
  margin-right: 90px;
}

.el-button.more-menu-button {
  color: #7d7d7d;
  display: block;
  margin-left: 0;
  padding: 8px 0 8px 6px;
  cursor: pointer;
}

.el-button.more-menu-button label {
  margin-left: 6px;
  cursor: pointer;
}

.stat {
  margin-bottom: 20px;
  padding: 0 0px;
}

.stat .datas {
  padding: 0 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  cursor: pointer;
}

.stat .datas .data .number {
  font-weight: bold;
  font-size: 24px;
  line-height: 1;
  color: #9d9d9d;
}

.stat .datas .data .type {
  font-size: 10px;
  color: #9d9d9d;
  line-height: 2;
}

.stat .datas .data .number:hover,
.stat .datas .data .type:hover {
  color: #5f5f5f;
}

.stat .heatgrid {
  margin-top: 10px;
  padding: 0 20px;
}

.pinned_tags_empty {
  margin-left: 20px;
  color: #9d9d9d;
  font-size: 12px;
  margin-top: 8px;
  padding: 6px 10px;
  border-radius: 6px;
  display: inline-block;
  background: #efefef;
}

h3 {
  font-size: 12px;
  color: #ded1b7;
  padding-left: 20px;
  margin: 20px 0 0;
}

ul {
  color: #9d9d9d;
  font-size: 14px;
  list-style-type: none;
  padding-inline-start: 0;
  margin: 8px 0 18px;
}
.allTags_body {
  overflow: hidden;
}

.sidebar_ul li {
  line-height: 36px;
  padding-left: 20px;
  cursor: pointer;
  font-size: 14px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  border-radius: 5px;
}

.sidebar_ul li:hover {
  background: var(--hoverBg);
}

.sidebar_ul li.selected:hover {
  background: var(--green);
}

.sidebar_ul li svg {
  margin-right: 9px;
  width: 14px;
  height: 14px;
}

ul li.selected {
  background: var(--green);
  color: #ffffff;
  border-radius: 6px;
}

ul li.selected svg {
  color: #ffffff;
  fill: #ffffff;
}

ul.tags li {
  padding-left: 0;
}

ul.tags li.selected {
  background: transparent;
  color: #9d9d9d;
  border-radius: 0;
}

ul.tags li.selected div {
  background: #55bb8e;
  color: #ffffff;
  border-radius: 5px;
}

ul.tags li div:hover {
  background: #efefef;
}

ul li i {
  margin-right: 10px;
}

.stat .heatgrid.monthBox {
  margin-top: 5px;
}

.allTags {
  margin: 10px 0;
}

.allTags .allTags_header {
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  align-items: center;
  flex-direction: row;
  line-height: 16px;
  cursor: pointer;
  position: relative;
  padding: 0 5px;
}

.allTags .allTags_header .svg-icon {
  opacity: 0;
  width: 16px;
  height: 16px;
  padding: 4px;
  border-radius: 3px;
}

.allTags .allTags_header .svg-icon:hover {
  background-color: var(--hoverBg);
}
.allTags .allTags_header .rightIcon {
  margin-right: 8px;
}
.mobile .allTags .allTags_header .rightIcon {
  margin-right: 11px;
}

.allTags .allTags_header div {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  cursor: pointer;
  height: 19px;
}
.allTags .allTags_header .allTags_title {
  font-size: 12px;
  padding-left: 4px;
  color: #ded1b7;
  font-weight: bolder;
}

.allTags .allTags_header:hover span {
  color: #9d9d9d;
}

.allTags .allTags_header:hover .svg-icon {
  /* display: block; */
  opacity: 1;
}

.allTags .allTags_header i {
  opacity: 0;
  color: #9d9d9d;
}

.allTags .allTags_header:hover i {
  opacity: 1;
}

.allTags .tag_overlimit:hover {
  color: #9d9d9d;
  cursor: pointer;
}

.recycle {
  cursor: pointer;
  line-height: 36px;
  padding-left: 20px;
  color: #9d9d9d;
  font-size: 14px;
  font-weight: normal;
}

.recycle:hover {
  border-radius: 5px;
  background: var(--hoverBg);
}

.recycle svg {
  fill: currentColor;
  margin-right: 8px;
  position: relative;
  top: 2px;
}

.selected {
  background: var(--green);
  color: #ffffff;
  border-radius: 5px;
}

.selected:hover {
  background: var(--green);
}

.selected svg {
  fill: currentColor;
}

.mobile .allTags .allTags_header i,
.mobile .allTags .allTags_header .svg-icon {
  opacity: 1;
}

/* .sidebar_ul li.selected:hover {
	background: #55bb8e;
	color: #ffffff;
	border-radius: 5px;
} */

.arrow-down svg {
  transform: rotate(90deg);
  animation: arrowDown 0.3s ease-in-out;
}

@keyframes arrowDown {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(90deg);
  }
}

.arrow-right svg {
  transform: rotate(0deg);
}

.el-button.more-menu-button:hover {
  color: #55bb8e;
}

.pinned_tip {
  font-size: 12px;
  padding: 0px 20px;
  margin-bottom: 24px;
  margin-top: 10px;
}
</style>

<style>
.el-aside:hover i.expand {
  opacity: 1;
}

.el-aside:hover .allTags_header > div > i {
  opacity: 1;
}
</style>
<style scoped lang="scss">
.heatgridTip {
  font-size: 12px;
  padding: 10px 20px;
  padding-bottom: 0px;
}
</style>
